import { defaultThumbnailConfig as e } from "./index.es74.js";
const a = {}, l = {
  inEditMode: !1,
  visualizationType: "calloutbox",
  poiCalloutBoxConfig: e,
  pinPalette: {
    paletteColors: [[94, 99, 229]],
    paletteName: "POI-1-TA1"
  },
  offsetMap: {}
};
export {
  a as chainVenuesDefaultFetchFilters,
  l as chainVenuesDefaultVisualFilters
};
//# sourceMappingURL=index.es76.js.map
